module.exports = __webpack_public_path__ + "static/parade-2019-house15-8a11234d4d75cf549b0ca12d2858f1f2.jpg";